export default __webpack_public_path__ + "static/media/zevellie.4fa94d45.jpeg";